import React from 'react';

import "./style.css"
import { Select, Modal, Button, Input, Icon, Table, message, LocaleProvider } from 'antd';
import EventSet from "./../../../assets/PubJs/hcPub"
import $ from "jquery"
import { Hcurl } from "./../../../constants/index"//获取公共路径
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import law from "./../../../assets/images/YWTJ.svg"//图片
const Option = Select.Option;
const Search = Input.Search;


let _AlwayUseList = null
class AlwayUseList extends React.Component {
    state = {
        data: [],
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: true,
            showQuickJumper: true,
            total: 0
        },
        loading: false,
    };

    //分页、排序等改变事件
    handleTableChange = (pagination, filters, sorter) => {
        this.setState({
            pagination: pagination,
            sorters: sorter
        },()=>{
            _AlwayUseList.fetch(_LawModal.state.signID)
        });
    };


    //事件：更具条件，对表格进行渲染
    fetch = (e) => {
        this.setState({ loading: true });
        $.ajax({
            url: Hcurl+"/HomePage/GetLawDetailsByID?key="+e+"&Content="+_LawModal.state.tableWord+"&pageSize="+_AlwayUseList.state.pagination.pageSize+"&pageNo="+_AlwayUseList.state.pagination.current,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            async: false,
            success: function (e) {
                let data=JSON.parse(e)
                const pagination = { ..._AlwayUseList.state.pagination };
                pagination.total = data.count;
                _AlwayUseList.setState({
                    loading: false,
                    data: data.Data,
                    pagination,
                });

            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    };

    handSearch(){
        let pagination=_AlwayUseList.state.pagination
        pagination.current=1;
        _AlwayUseList.setState({
            pagination
        },()=>{
            _AlwayUseList.fetch(_LawModal.state.signID)
        })
    }

    //组件完成后
    componentDidMount() {
        _AlwayUseList = this;
    }

    //渲染
    render() {
        const columns =  [{
            title: '章',
            dataIndex: 'LD_Chapter',
            width: 180

        }, {
            title: '节',
            dataIndex: 'LD_Section',
            width: 100
        }, {
            title: '详细内容',
            dataIndex: 'LD_Content',
        }];
        return (
            <div style={{ background: "#fff", padding: 24 }}>
                <LocaleProvider locale={zh_CN}>
                    <Table
                        rowKey={record => record.ID}
                        pagination={this.state.pagination}
                        loading={this.state.loading}
                        onChange={this.handleTableChange}
                        size="middle"
                        bordered
                        columns={columns}
                        dataSource={this.state.data}
                    />
                </LocaleProvider>
            </div>
        )
    }
}

let _LawModal=null;
class LawModal extends React.Component {
    state = {
        visible: false,
        isSign:"标记",//标记，取消标记文字
        signID:"",//当前选择法律的id
        lawData:[],//法律列表
        keyWord:"",//法律列表关键词
        tableWord:"",//表格关键词
    };

    //弹出modal
    showModal = (e) => {
        this.setState({
            visible: true,
        });
        //console.log(e,"eeeeeeeee")
        _LawModal.getLawListByKey("");
        _LawModal.fristList(e);
        setTimeout(function () {
            $(".ant-table-body").addClass("bodyScroll")
        },10)

    };

    fristList(e) {
        setTimeout(function () {
            if (e===""){
                if (_LawModal.state.lawData.length!==0){
                    $(".moadlLawList p").removeClass("cur");
                    $("#"+_LawModal.state.lawData[0].ID).addClass("cur");
                    _LawModal.setState({
                        signID:_LawModal.state.lawData[0].ID,
                        isSign:_LawModal.state.lawData[0].BeMarked=="0"?"标记":"取消标记"
                    });
                    _AlwayUseList.fetch(_LawModal.state.lawData[0].ID)
                }
            }else {
                $(".moadlLawList p").removeClass("cur");
                $("#"+e.ID).addClass("cur")
                _LawModal.setState({
                    signID:e.ID,
                    isSign:e.BeMarked == "0" ? "标记" : "取消标记"
                });
                _AlwayUseList.fetch(e.ID)
            }


        },100)
    }

    //根据关键词获取法律列表
    getLawListByKey(e){
        $.ajax({
            url: Hcurl+"/HomePage/GetLawsByKeyWord?key="+e+"&usercode="+EventSet.getUserInfo().CU_Code,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            async: false,
            success: function (res) {
                _LawModal.setState({
                    lawData:res
                })
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }

    //输入框值改变
    searchChange = (e) => {
        _LawModal.setState({
            keyWord:e.target.value
        });
        this.getLawListByKey(e.target.value)
    };

    //标记事件
    signLaw(){
        let data={
            "LawID": _LawModal.state.signID,
            "UserCode": EventSet.getUserInfo().CU_Code,
        };
        let sinUrl=Hcurl+"/HomePage/MarkLaw";
        if (_LawModal.state.isSign==="标记"){
            sinUrl=Hcurl+"/HomePage/MarkLaw"
        }else {
            sinUrl=Hcurl+"/HomePage/UnMarkLaw"
        }
        $.ajax({
            url: sinUrl,
            type: "post",
                                            headers: {
                                                "token": EventSet.getUserInfo()['token']
                                            },
            data:data,
            async: false,
            success: function (res) {
                if (res.split("|")[0]==="true"){
                    message.success(res.split("|")[1]);
                    _LawModal.setState({
                        isSign:_LawModal.state.isSign=="标记"?"取消标记":"标记"
                    })
                    _LawModal.getLawListByKey(_LawModal.state.keyWord)
                }else {
                    message.error(res.split("|")[1])
                }
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }

    //法律列表点击
    lawListChange(e){
        $(".moadlLawList p").removeClass("cur")
        $("#"+e.ID).addClass("cur")
        this.setState({
            isSign:e.BeMarked=="0"?"标记":"取消标记",
            signID:e.ID,
            tableWord:""
        }, () => {
            const pagination = _AlwayUseList.state.pagination
            pagination.current = 1
            _AlwayUseList.setState({
                pagination
            }, () => { _AlwayUseList.fetch(_LawModal.state.signID)})
        })

    }

    //弹出框取消事件
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
        setTimeout(function () { $(".ant-table-body").removeClass("bodyScroll") }, 500)
       
        _LawData.getHomePageLawList()
    };

    //表格上方关键字改变
    inputSearch(e){
        this.setState({
            tableWord:e.target.value
        })
    }

    //组件完成前
    componentWillMount(){
        _LawModal=this;
    }

    //渲染
    render() {
        return (
            <div>
                <Modal
                    width={1200}
                    title="法律法规"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={null}
                >
                    <div className={"lawModal clear"}>
                        <div className={"lawSearchList left"}>
                            <div className={"signLawBtn"}>
                                <Button disabled={this.state.lawData.length === 0 ? true : false} onClick={() => _LawModal.signLaw()} type={"primary"}>{this.state.isSign}</Button>
                            </div>
                            <div style={{marginTop:"12px"}}>
                                <Search
                                    placeholder="请输入法律法规名称"
                                    onChange={this.searchChange}
                                />
                            </div>
                            <div className={"moadlLawList"}>
                                {
                                    this.state.lawData.map(function (e) {
                                        return <p onClick={()=>_LawModal.lawListChange(e)} id={e.ID} key={e.ID}><Icon style={{ display: e.BeMarked == 1 ? "inline-block" : "none" }} type="star"/>{e.Law_Name}</p>
                                    })
                                }
                            </div>
                        </div>
                        <div className={"lawTable right"}>
                            <div id="tableSearch" className="tableSearch">
                                <Input value={this.state.tableWord} onChange={this.inputSearch.bind(this)} style={{ width: '200px', marginRight: "16px", marginTop: "2px" }} placeholder="输入关键字搜索" />
                                <Button  type="primary" onClick={()=>_AlwayUseList.handSearch()}>搜索</Button>
                            </div>
                            <AlwayUseList/>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

//法律法规头部
class LawTitle extends React.Component{

    state={
        type:"",
        year:"",
        beginTime:"",
        endTime:""
    };

    render(){
        return(
            <div className="C_topTitle clear">
                <img style={{ width: "18px", position: "relative", top: "7.5px", marginRight: "6px" }} className="left" src={law} alt="" />
                <span className="left">法律法规</span>
                <div className="right" >
                    <span style={{cursor:"pointer"}} onClick={()=>_LawModal.showModal("")}>查看全部</span>
                </div>
            </div>
        )
    }

}

//法律法规列表
let _LawData=null;
class LawData extends React.Component{
    state={
        sinLawData:[],
    };

    //获取首页法律列表
    getHomePageLawList() {
        let _this=this;
        $.ajax({
            url: Hcurl +"/HomePage/GetDefaultPageLaws?usercode="+EventSet.getUserInfo().CU_Code,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            async: false,
            success: function (res) {
                //console.log(res,"res")
                _this.setState({
                    sinLawData:res
                })
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
    }

    componentDidMount() {
        _LawData=this;
        this.getHomePageLawList()
    }

    render(){
        return(
            <div className={"lawcon"} style={{height:this.props.hei-70}}>
                {
                    this.state.sinLawData.map(function (e) {
                        return   <div key={e.ID} onClick={()=>_LawModal.showModal(e)}  className={"lawList"} >
                            <span className={"con"}>《{e.Law_Name}》</span>
                            <span className={"time"}>{e.JoinDate.split("T")[0].toString()}</span>
                        </div>
                    })
                }
            </div>
        )
    }

}

class App extends React.Component{
    render(){
        return(
            <div className="C_content">
                <LawModal/>
                <LawTitle/>
                <div className="C_content_son">
                    <LawData hei={this.props.hei}/>
                </div>
            </div>
        )
    }
}
export default App


// WEBPACK FOOTER //
// ./src/components/Content/Home/Law.js